import { isOneMan, isSupplierDirect } from '@utils/delivery/deliveryHelper';

export function orderContainsMixedDeliveryTypes(deliveries) {
  if (deliveries) {
    const containsOneMan = deliveries.some((d) => isOneMan(d.type));
    const containsSupplierDirect = deliveries.some((d) => isSupplierDirect(d.type));
    const containsOtherTypes = deliveries.some((d) => !isSupplierDirect(d.type) && !isOneMan(d.type));

    return containsOneMan && containsSupplierDirect && !containsOtherTypes;
  }

  return false;
}

export function shouldShowCollectionHelpText(params) {
  const { deliveries: paramDeliveries, id, isChildItem, orderComplete, state = {} } = params;

  const deliveries = paramDeliveries || state.delivery?.deliveries;
  if (!deliveries) return false;

  if (orderComplete || state.app?.orderComplete) return false;

  if (isChildItem) return false;

  const supplierDirectDeliveries = deliveries.filter((d) => isSupplierDirect(d.type));
  const supplierDirectItemIds = supplierDirectDeliveries.reduce(
    (acc, delivery) => [...acc, ...delivery.items.map((d) => d.id)],
    [],
  );
  if (!supplierDirectItemIds.includes(id)) return false;

  const showCollectionHelp = orderContainsMixedDeliveryTypes(deliveries);
  if (!showCollectionHelp) return false;

  return true;
}
